module.exports = __webpack_public_path__ + "static/painting-b866ef19c69d66819d59f42c90b27acb.png";